var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"inputs"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }